export default __webpack_public_path__ + "static/media/raki_detail9.355ae818.jpg";